import { render, staticRenderFns } from "./productConfig.vue?vue&type=template&id=1b6a3e38&scoped=true"
import script from "./productConfig.vue?vue&type=script&lang=ts"
export * from "./productConfig.vue?vue&type=script&lang=ts"
import style0 from "./productConfig.vue?vue&type=style&index=0&id=1b6a3e38&prod&lang=css"
import style1 from "./productConfig.vue?vue&type=style&index=1&id=1b6a3e38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6a3e38",
  null
  
)

export default component.exports